(function() {
    'use strict';

    angular
        .module('app')
        .directive('treeview', closetreeview);

    closetreeview.$inject = ['$window', '$q'];
    
    function closetreeview ($window, $q) {
        // Usage:
        //     <closetreeview></closetreeview>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA'
        };
        return directive;

        function link(scope, element, attrs) {
            var menu = element[0].getElementsByClassName("treeview-menu");
            scope.collapseTreeView = function (speed) {
                var deferred = $q.defer();
                angular.element(menu).slideUp(speed, function () {
                    angular.element(menu).removeClass('menu-open');
                    deferred.resolve();
                });
                angular.element(menu).parent("li").removeClass("active");
                return deferred.promise;
            }
        }
    }

})();